import { fromJS } from 'immutable'
import * as categories from './contentAssetCategoriesActions'

const initialState = fromJS({
	isLoading: false,
	isCreating: false,
	loaded: false,
	categories: []
})

const contentAssetCategoriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case categories.IS_LOADING_CATEGORIES: {
			return state.set('isLoading', action.status)
		}
		case categories.SET_CATEGORIES: {
			return state.set('categories', fromJS(action.data)).set('loaded', true)
		}
		case categories.IS_CREATING_CATEGORY: {
			return state.set('isCreating', action.status)
		}
		case categories.ADD_CATEGORY: {
			const current = state.get('categories').toJS()
			return state.set('categories', fromJS([...current, action.category]))
		}
		default:
			return state
	}
}

export default contentAssetCategoriesReducer
